module.exports = __webpack_public_path__ + "static/media/testimony1.a512ecc1.png";